import * as React from 'react';
import { Component } from 'react';
import { SectionContent } from '@components/Sections/Sections.s';
import { SectionTeaserWrapper, TeaserVideoWrapper, SectionTeaserTextWrapper } from './SectionTeaser.s';
import { HeadingCenter, Paragraph } from '@components/Typos/Typos.s';
import { TeaserVideo } from '@components/Videos/TeaserVideo';

export class SectionTeaser extends Component<{}, {}> {

  render(): JSX.Element {
    return (
      <SectionTeaserWrapper>
        <SectionContent>
          <TeaserVideoWrapper>
            <TeaserVideo />
            {/* <div style={{ height: '338px', width: '600px', background: 'red' }} /> */}
          </TeaserVideoWrapper>
          <SectionTeaserTextWrapper>
            <HeadingCenter>
              Plus aucune excuse pour rater une expo
            </HeadingCenter>
            <Paragraph>
              Start te simplifie la vie en te proposant une série d’expositions à faire en fonction de ton humeur.
              Préviens les potes, votre prochaine sortie c’est au musée !
            </Paragraph>
          </SectionTeaserTextWrapper>
        </SectionContent>
      </SectionTeaserWrapper>
    );
  }

}



// WEBPACK FOOTER //
// src/app/src/components/SectionTeaser/SectionTeaser.tsx